"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _themeProvider = require("@mmc/theme-provider");

var _tabButton = _interopRequireDefault(require("./tab-button.css"));

var TabButton = function TabButton(_ref) {
  var _clsx;

  var value = _ref.value,
      index = _ref.index,
      selected = _ref.selected,
      _onClick = _ref.onClick,
      buttonLabelFormatter = _ref.buttonLabelFormatter;
  var theme = (0, _themeProvider.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: (0, _clsx2["default"])(theme.inputsAndOptions, _tabButton["default"].tabButton, (_clsx = {}, _clsx[_tabButton["default"].selected] = selected, _clsx)),
    onClick: function onClick() {
      return _onClick(value, index);
    }
  }, buttonLabelFormatter ? buttonLabelFormatter(value) : value);
};

var _default = TabButton;
exports["default"] = _default;